import { ButtonText } from "components/Atoms/Button";
import React from "react";

interface Props {
  subtopic: server.dto.AvailableMergeFieldSubTopic
  onSelect: (mergefield: string) => void
}

const MergeSubTopic = (props: Props) => {
  if (props.subtopic.mergeFields.length === 0) {
    return null;
  }

  return <div className="merge-sub-topic-wrapper">
    <h3>{props.subtopic.label}</h3>

    <div className="merge-sub-topic-grid">
      {props.subtopic.mergeFields.map(mf => (
        <React.Fragment key={mf.mergeField}>
          <div>{mf.label}</div>
          <ButtonText
            label={`«${mf.mergeField}»`}
            style={{ justifyContent: "left" }}
            onClick={() => props.onSelect(`«${mf.mergeField}»`)}
          />
        </React.Fragment>
      ))}
    </div>
  </div>;
};

export default MergeSubTopic;